import axiosInstance from "./axiosInstance";

// GET all AdviceCare
export const getAdvice = async () => {
  try {
    const response = await axiosInstance.get("/adviceCare");
    return response.data.data; 
  } catch (error) {
    console.error("Failed to fetch AdviceCare:", error);
    throw error;
  }
};

// GET all AdviceCareBlog
export const getAdviceCareBlog = async () => {
  try {
    const response = await axiosInstance.get("/adviceCareBlog");
    return response.data.data; 
  } catch (error) {
    console.error("Failed to fetch AdviceCareBlog:", error);
    throw error;
  }
};